export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";